import React, { Component } from 'react'
import qs from 'qs'
import _ from 'lodash'
import Button from 'material-ui/Button'
import { assets, translations } from '../../../config'
import P from '../../../components/P'
import sdk from '../../../digitalStoreSdk'
import MarketingOptInForm from '../MarketingOptInForm'
import style from './style'

const invalidTokenError = new Error('Invalid token.')

const LOADING = 'LOADING'
const MISSING_TOKEN = 'MISSING_TOKEN'
const VALID_TOKEN = 'VALID_TOKEN'
const INVALID_TOKEN = 'INVALID_TOKEN'
const SUCCESS_OPT_IN = 'SUCCESS_OPT_IN'

class MarketingOptIn extends Component {
  state = {
    status: LOADING
  }
  getQueryParams = () => {
    const queryString = _.get(this.props, 'location.search', '').slice(1)
    const { customerId, token } = qs.parse(queryString)
    return { customerId, token }
  }
  validateToken = () => {
    const { customerId, token } = this.getQueryParams()
    return sdk.customers
      .validateCustomerToken({ token })
      .then(tokenResult => {
        if (
          tokenResult.customerId === customerId &&
          tokenResult.tokenType === 'marketingOptIn'
        ) {
          return tokenResult
        } else {
          throw Error()
        }
      })
      .catch(error => {
        console.error(error)
        throw invalidTokenError
      })
  }
  componentDidMount () {
    const { customerId, token } = this.getQueryParams()
    if (!customerId || !token) {
      this.setState({ status: MISSING_TOKEN })
    } else {
      this
        .validateToken()
        .then(() => {
          this.setState({ status: VALID_TOKEN })
        })
        .catch(error => {
          this.setState({ status: INVALID_TOKEN })
        })
    }
  }
  onSubmissionComplete = () => {
    this.setState({ status: SUCCESS_OPT_IN })
  }
  renderContent = () => {
    const { status } = this.state
    if (status === VALID_TOKEN) {
      const { customerId, token } = this.getQueryParams()
      return (
        <div style={style.buttonContainer}>
          <P value={translations('Opt In Confirmation')} />
          <div style={style.formContainer}>
            <MarketingOptInForm
              onSubmissionComplete={this.onSubmissionComplete}
              customerId={customerId}
              token={token}
            />
          </div>
        </div>
      )
    } else {
      return <P value={translations(`FLAG_${status}`)} />
    }
  }
  render () {
    return (
      <div style={style.container}>
        <div style={style.logoContainer}>
          <img src={assets.logo} style={style.logo} />
        </div>
        <div style={style.messageContainer}>
          {this.renderContent()}
        </div>
      </div>
    )
  }
}

export default MarketingOptIn



// WEBPACK FOOTER //
// ./src/containers/MarketingOptIn/MarketingOptIn/MarketingOptIn.js